import React, { useState } from "react";
import styled from "styled-components";
import useProductName from "brand-customization/useProductName";
import { useTranslation } from "react-i18next";
import { Button, Panel } from "components/bootstrap";
import { Spinner } from "components/common";
import UsersDomain from "domainActions/users/UsersDomain";
import CreateTokenForm from "components/users/CreateTokenForm";
import AppConfig from "util/AppConfig";
import ForwarderInputInformation from "forwarder/wizard/select-forwarder-step/start-new-forwarder-steps/ForwarderInputInformation";
import useForwardersConfiguration from "forwarder/wizard/select-forwarder-step/hooks/useForwardersConfiguration";
const StyledButton = styled(Button)`
  margin-top: 20px;
`;
const CreateTokenStep = ({
  eventKey,
  token = null,
  user = null,
  onTokenCreate,
  onStepComplete,
  forwarderInputs = null
}) => {
  const { t } = useTranslation("enterprise_forwarder");
  const productName = useProductName();
  const [isCreatingToken, setIsCreatingToken] = useState(false);
  const { data, isLoading } = useForwardersConfiguration();
  const disableForm = !isLoading && !(data == null ? void 0 : data.forwarder_service_autostart) && !AppConfig.isCloud() && (forwarderInputs == null ? void 0 : forwarderInputs.length) <= 0;
  if (!user) {
    return /* @__PURE__ */ React.createElement(Panel, { eventKey }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, null, /* @__PURE__ */ React.createElement(Panel.Toggle, { tabIndex: 0 }, t("create_token.heading")))), /* @__PURE__ */ React.createElement(Panel.Body, { collapsible: true }, /* @__PURE__ */ React.createElement(Spinner, null)));
  }
  const handleCreateToken = ({ tokenName, tokenTtl }) => {
    setIsCreatingToken(true);
    const promise = UsersDomain.createToken(user.id, tokenName, tokenTtl);
    promise.then(onTokenCreate).finally(() => setIsCreatingToken(false));
  };
  return /* @__PURE__ */ React.createElement(Panel, { eventKey }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, null, /* @__PURE__ */ React.createElement(Panel.Toggle, { tabIndex: 0 }, t("create_token.heading")))), /* @__PURE__ */ React.createElement(Panel.Body, { collapsible: true }, token ? /* @__PURE__ */ React.createElement("p", null, t("create_token.already_created")) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("create_token.intro", { productName })), disableForm && /* @__PURE__ */ React.createElement(ForwarderInputInformation, { forwarderInputs }), /* @__PURE__ */ React.createElement(
    CreateTokenForm,
    {
      disableForm,
      creatingToken: isCreatingToken,
      onCreate: handleCreateToken,
      forceDefaultTtl: "P100Y"
    }
  ), /* @__PURE__ */ React.createElement(StyledButton, { disabled: disableForm, bsStyle: "primary", bsSize: "sm", onClick: () => onStepComplete() }, t("create_token.skip")))));
};
export default CreateTokenStep;
